import React from 'react';

interface WelcomeModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const WelcomeModal: React.FC<WelcomeModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 p-3 md:p-4">
      {/* Backdrop with blur */}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity" onClick={onClose} />

      {/* Modal Content - Scrollable with max height */}
      <div className="relative bg-white rounded-xl md:rounded-2xl shadow-2xl max-w-xl w-full max-h-[90vh] max-h-[90dvh] flex flex-col transform transition-all animate-in fade-in zoom-in duration-200">
        {/* Scrollable Content Area */}
        <div className="flex-1 overflow-y-auto">
        {/* Header */}
          <div className="p-4 md:p-8 pb-2 md:pb-4">
            <h2 className="text-xl md:text-2xl font-bold text-slate-900 mb-2 md:mb-3">
            Welcome to JobVital!
          </h2>
            <p className="text-xs md:text-sm text-slate-600 leading-relaxed">
            If you have come through an application link, rest assured your job application has been received. 
            Please make sure your CV is up to date in your account.
          </p>
        </div>

        {/* Content Sections */}
          <div className="px-4 md:px-8 pb-4 md:pb-6 space-y-3 md:space-y-4">
          {/* Benefit 1: Companies Searching */}
            <div className="border-2 border-slate-200 rounded-xl p-3 md:p-5 bg-slate-50/50 hover:bg-slate-50 transition-colors">
              <h3 className="text-sm md:text-base font-semibold text-slate-900 mb-1 md:mb-2">
              Companies are searching for you
            </h3>
              <p className="text-xs md:text-sm text-slate-600 leading-relaxed">
              Companies and Recruiters are actively searching JobVital for candidates like you, that match your background
            </p>
          </div>

          {/* Benefit 2: Jobs Matched */}
            <div className="border-2 border-slate-200 rounded-xl p-3 md:p-5 bg-slate-50/50 hover:bg-slate-50 transition-colors">
              <h3 className="text-sm md:text-base font-semibold text-slate-900 mb-1 md:mb-2">
              Jobs matched to your background
            </h3>
              <p className="text-xs md:text-sm text-slate-600 leading-relaxed">
              Skip the job search - jobs are delivered straight to your inbox weekly
            </p>
          </div>

          {/* Information: Stay Active */}
            <div className="border-2 border-amber-200 rounded-xl p-3 md:p-5 bg-amber-50/70 hover:bg-amber-50 transition-colors">
              <div className="flex items-start gap-2 md:gap-3">
              {/* Info Icon */}
                <div className="flex-shrink-0 w-4 h-4 md:w-5 md:h-5 mt-0.5">
                  <div className="w-4 h-4 md:w-5 md:h-5 rounded-full border-2 border-amber-500 flex items-center justify-center">
                    <span className="text-[10px] md:text-xs font-bold text-amber-600">i</span>
                </div>
              </div>
              
              {/* Text Content */}
                <p className="text-xs md:text-sm text-slate-600 leading-relaxed flex-1">
                Staying active and logging in weekly keeps your profile visible to hiring teams
              </p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer with OK Button - Always visible */}
        <div className="flex-shrink-0 p-4 md:p-8 pt-2 md:pt-2 flex justify-end border-t border-slate-100">
          <button
            onClick={onClose}
            className="bg-slate-900 text-white px-6 md:px-8 py-2 md:py-2.5 rounded-xl font-semibold hover:bg-slate-800 hover:shadow-lg hover:-translate-y-0.5 active:translate-y-0 active:shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-900 focus:ring-offset-2 transition-all duration-200 min-w-[80px] md:min-w-[100px] text-sm md:text-base"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

